import {
    login,
    logout,
    useAuthValues
} from "@/stores/auth-store";
import { useUserValues } from "@/stores/user-store";

export const useAuth = () => {
    const authState = useAuthValues();
    const user = useUserValues();

    return {
        setupCompleted: authState.setupCompleted,
        user: user,
        isAuthenticated: authState.isAuthenticated,
        isLoading: authState.isLoading,
        login,
        logout
    };
};
